module.exports = __webpack_public_path__ + "assets/img/login-bg-repeat2.b0ae5042.png";